import api from ".";
import cookiesModifier from "../utils/cookies";

import { IComponent } from "../types/component";

export const createComponent = async (data: IComponent) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`components`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateComponent = async (data: IComponent) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`components/${data.id}`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteComponent = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`components/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}